import * as React from 'react';
import {
  List,
  ListItem,
  Button,
  ListItemTitle,
  ListItemText
} from '../../../Components';
import { MembroDaBancaModel, PROFESSOR_STORE } from '../../../Store';
import styled from 'styled-components';
import { format } from 'date-fns';
import { inject, observer } from 'mobx-react';
import { ListItemActions } from '../../../Components/List/ListItemActions';

/*
  interfaces
*/
interface IProps {
  convites: MembroDaBancaModel[];
  mostrarBotoes?: boolean;
}

/*
  styled components
*/
const StyledItem = styled(ListItem)`
  display: flex;
`;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin: 10px;
`;

/*
  component: ConvitesList
*/
@inject(PROFESSOR_STORE)
@observer
export class ConvitesList extends React.Component<IProps> {
  responderConvite = async (monografiaId: number, resposta: boolean) => {
    const store = this.props[PROFESSOR_STORE];

    await store
      .responderConvite(monografiaId, resposta)
      .then(() => store.getConvites());
  };

  render() {
    const { convites } = this.props;

    return (
      <List showBorder={false}>
        {convites &&
          convites.map((m, i) => (
            <StyledItem
              key={i}
              onClick={() => {
                window.location.pathname = `professor/convite/${m.monografia.id}`;
              }}
            >
              <ListItemTitle> {m.monografia.professor.nome} </ListItemTitle>
              <ListItemText>
                {m.monografia.agendamento ?
                  format(
                    m.monografia.agendamento.dataInicio,
                    'DD/MM/YYYY HH:mm'
                  )
                  + ' - ' + m.monografia.agendamento!.local
                  : format(
                    m.monografia.dataDeApresentacaoSugerida!,
                    'DD/MM/YYYY HH:mm'
                  )
                }
              </ListItemText>
              <ListItemText> {m.monografia.titulo} </ListItemText>
              <ListItemActions>
                <StyledButton
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_API_URL}arquivo/${
                      m.monografia!.deposito!.identifier
                      }`
                    )
                  }
                >
                  Baixar TCC
                </StyledButton>
                {this.props.mostrarBotoes &&
                  <>
                    <StyledButton
                      color={'errorColor'}
                      onClick={e => {
                        this.responderConvite(m.monografiaId, false);
                      }}
                    >
                      Recusar
                    </StyledButton>
                    <StyledButton
                      color={'approvedColor'}
                      onClick={e => {
                        this.responderConvite(m.monografiaId, true);
                      }}
                    >
                      Aceitar
                    </StyledButton>
                  </>
                }
              </ListItemActions>
            </StyledItem>
          ))}
      </List>
    );
  }
}
